import { UserDTO } from "../models/UserDTO";

const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const getUsers = async () :Promise<UserDTO[]> => {
    const response = await fetch (`${API_BASE_URL}/User/GetAll`)
    const data = response.json()

    return data
}

const addUser = async (user: UserDTO) => {
    const response = await fetch(`${API_BASE_URL}/User/Add`, {
        method: "POST",
        headers: { "Content-Type": "application/json; charset= utf-8" },
        body: JSON.stringify(user),
    })
    
    return response
}

const updateUser = async (user: UserDTO) => {
    const response = await fetch(`${API_BASE_URL}/User/Update`, {
        method: "POST",
        headers: { "Content-Type": "application/json; charset= utf-8" },
        body: JSON.stringify(user),
    })
    
    return response
}

const deleteUser = async (id: number) => {
    const response = await fetch(`${API_BASE_URL}/User/Delete/${id}`, {
        method: "POST",
        headers: { "Content-Type": "application/json; charset= utf-8" },
    })
    
    return response
}

const UserService = {
    getUsers, addUser, updateUser, deleteUser
}

export default UserService